import { persistStore, persistReducer } from 'redux-persist'

export const SessionReducer = (state = {}, action) => {
    switch (action.type) {
        case "LOGIN":
            console.log("LOGIN");
            return state = action.payload;
        case "LOGOUT":
            console.log("clear all DATA ");
            persistStore.purge();
            return state = {};
        default:
            return state;
    }
}

export default SessionReducer;